import { defineStore } from "pinia";

export const useExchangeRateStore = defineStore('exchange', {
    state: () => ({
        exchange: window.__pt.exchange || {}
    }),
    getters: {
        getExchange: (state) => state.exchange,
    },
    actions: {
        setExchangeRate(rate) {
            this.exchange = rate;
        }
    }
});